import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import MaterialTable from 'material-table'


const tableRef = React.createRef();

const dateKeys = {
    start: 'enduringpromises.com.emails.table.dates.start',
    end: 'enduringpromises.com.emails.table.dates.end'
};
const sessionKeys = {
    search: 'enduringpromises.com.emails.table.search'
};

const useStyles = makeStyles(theme => ({
    formField: {
      marginLeft: theme.spacing(2),
    },
    formButton: {
        marginLeft: theme.spacing(1),
    },
    paper: {
        padding: theme.spacing(3),
    },
}));

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.log(error);
    }

    render() {
        if (this.state.hasError) {
            return <p>Something went wrong</p>;
        }

        return this.props.children;
    }
}

const MaterialTableTable = (props) => {
    const {
        dateStart,
        dateEnd
    } = props;

    const [state, setState] = React.useState({
        columns: [
            {
                title: 'To',
                render: rowData => (
                    <div>
                        {Object.keys(rowData.to).join(', ')}
                    </div>
                )
            },
            {
                title: 'CC',
                render: rowData => (
                    <div>
                        {rowData.cc ? Object.keys(rowData.cc).join(', '): ''}
                    </div>
                )
            },
            { title: 'Subject', field: 'subject' },
            { title: 'Date Sent', field: 'date_sent', type: 'date' },
        ],
    });

    /* TODO: add email action, and make balance link to balance detail for couple */

    const pageSizeOptions = [10, 30, 50, 100, 250];

    const fetchData = query =>
        new Promise((resolve, reject) => {
            let url = '/api/emails/sent?';

            /* set the search to local storage */
            localStorage.setItem(sessionKeys.search, query.search);

            /* TOOD: find better way to do this */
            query.dateStart = query.dateStart ? query.dateStart : dateStart;
            query.dateEnd = query.dateEnd ? query.dateEnd : dateEnd;

            /* TODO: use orderBy and filters */
            url += 'per_page=' + query.pageSize
            url += '&page=' + (query.page + 1)
            url += '&search=' + query.search
            url += '&orderBy=' + (query.orderBy ? query.orderBy.field : '')
            url += '&orderDirection=' + query.orderDirection
            url += '&dateStart=' + dateFormatter(query.dateStart);
            url += '&dateEnd=' + dateFormatter(query.dateEnd);
            if (query.filters.length) {
                url += '&' + query.filters.map(x => `${x.column.field}=`+encodeURI(x.value)).join('&')
            }
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    tableRef.current.props.options.pageSizeOptions = pageSizeOptions;
                    resolve({
                        data: result.data,
                        page: result.current_page - 1,
                        totalCount: result.total,
                    })
                })
            }
        )

    let history = useHistory();

    function handleEditEmail(event, rowData) {
        history.push(`/admin/emails/${rowData.id}`);
    }

    const defaultSearchText = localStorage.getItem(sessionKeys.search) || '';

    return (
        <React.Fragment>
            <MaterialTable
                title="Emails List"
                columns={state.columns}
                data={fetchData}
                actions={[
                    {
                        icon: 'visibility',
                        tooltip: 'View',
                        onClick: handleEditEmail
                    },
                    {
                        icon: 'refresh',
                        tooltip: 'Refresh Data',
                        isFreeAction: true,
                        onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                    }
                ]}
                components={{
                    Container: Box,
                }}
                options={{
                    showTitle: false,
                    pageSize: 10,
                    pageSizeOptions: pageSizeOptions,
                    exportButton: true,
                    loadingType: 'linear',
                    emptyRowsWhenPaging: false,
                    sorting: false,
                    debounceInterval: 600,
                    padding: 'dense',
                    searchText: defaultSearchText,
                }}
                tableRef={tableRef}
            />
        </React.Fragment>
    );
};

const dateFormatter = date => {
    return [
        date.getFullYear(), date.getMonth()+1, date.getDate()
    ].join('-');
}

const EmailDatePicker = (props) => {
    const {
        dateStart,
        dateEnd
    } = props;

    const [selectedStartDate, setSelectedStartDate] = React.useState(dateStart);
    const [selectedEndDate, setSelectedEndDate] = React.useState(dateEnd);
    const classes = useStyles();

    const handleDateChange = date => {
        setSelectedStartDate(date);
    };

    const handleEndDateChange = date => {
        setSelectedEndDate(date);
    };

    const handleDateSet = () => {
        localStorage.setItem(dateKeys.start, selectedStartDate);
        localStorage.setItem(dateKeys.end, selectedEndDate);
        if (tableRef.current) {
            const query = tableRef.current.state.query;
            query.dateStart = selectedStartDate;
            query.dateEnd = selectedEndDate;
            query.page = 0;
            tableRef.current.onQueryChange();
        }
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="baseline"
            >
                <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Date sent filter"
                    helperText="Start Date"
                    format="MM/dd/yyyy"
                    value={selectedStartDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
                <KeyboardDatePicker
                    margin="normal"
                    id="date-end-picker-dialog"
                    format="MM/dd/yyyy"
                    helperText="End Date"
                    value={selectedEndDate}
                    onChange={handleEndDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    className={classes.formField}
                />
                <Button className={classes.formButton} onClick={handleDateSet}>Set</Button>
            </Grid>
        </MuiPickersUtilsProvider>
    );
};

const EmaiLTrackingList = () => {
    const classes = useStyles();

    const defaultDateStart = localStorage.getItem(dateKeys.start) ? new Date(localStorage.getItem(dateKeys.start)) : new Date(new Date().setMonth(new Date().getMonth() - 2));
    const defaultDateEnd = localStorage.getItem(dateKeys.end) ? new Date(localStorage.getItem(dateKeys.end)) : new Date();
    localStorage.setItem(dateKeys.start, defaultDateStart);
    localStorage.setItem(dateKeys.end, defaultDateEnd);

    const [dateStart, setDateStart] = React.useState(defaultDateStart);
    const [dateEnd, setDateEnd] = React.useState(defaultDateEnd);

    useEffect(() => {
        document.title = 'Sent Emails - Enduring Promises';
    });

    return (
        <Paper square className={classes.paper}>
            <div style={{ maxWidth: '100%' }}>
                <Typography variant="h6">Email Tracking</Typography>
                <Grid
                    container
                    spacing={2}
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={12} md={8} style={{maxWidth: 580}}>
                        <EmailDatePicker dateStart={dateStart} dateEnd={dateEnd} />
                    </Grid>
                </Grid>
                <ErrorBoundary>
                    <MaterialTableTable dateStart={dateStart} dateEnd={dateEnd} />
                </ErrorBoundary>
            </div>
        </Paper>
    )
}

export default EmaiLTrackingList;
